var map = {
	"./af/common.json": "./src/modules/finance/src/locales/af/common.json",
	"./en/common.json": "./src/modules/finance/src/locales/en/common.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/finance/src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";